import { render, staticRenderFns } from "./MenuSideBar.vue?vue&type=template&id=b20c8648&scoped=true"
import script from "./MenuSideBar.vue?vue&type=script&lang=js"
export * from "./MenuSideBar.vue?vue&type=script&lang=js"
import style0 from "./MenuSideBar.vue?vue&type=style&index=0&id=b20c8648&prod&lang=scss"
import style1 from "./MenuSideBar.vue?vue&type=style&index=1&id=b20c8648&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20c8648",
  null
  
)

export default component.exports